<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
  >

    <v-card class="vb-dialog vb-dialog-danger">
      <v-card-title class="bg-error d-flex justify-space-between mb-4">
        <span>{{$t('routes.recycleBin.restoreDeletedFiles')}}</span>
        <v-btn icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="scrollable" style="font-size: 1rem">
        {{ $t('routes.recycleBin.archivedFilesCannotBeRestored') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" variant="text" data-cy="dialog--false">
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  name: "RecycleBinArchivedDialog",

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },

  data: function() {
    return {};
  },

  methods: {
    closeDialog: function() {
      this.showDialog = false;
    }
  },

  computed: {
    showDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>

<style>
</style>
